<template>
  <span role="status" class="spinner-border" :style="style"><span class="sr-only">Spinning</span></span>
</template>

<script lang="ts" setup>

import { computed, defineProps } from 'vue';
import { useTheme } from '@/composable/ui/useTheme';
import { Color } from '@/store/theme.store';

const props = defineProps({
  size: {
    type: String as () => 'sm' | 'md' | 'lg',
    default: 'md',
  },
  color: {
    type: String as () => Color,
    default: 'primary',
  },
});

const theme = useTheme();

const sizes = {
  sm: 20,
  md: 26,
  lg: 30,
};

const boarders = {
  sm: 3,
  md: 5,
  lg: 8,
};

const style = computed(() => ({
  width: `${sizes[props.size]}px`,
  height: `${sizes[props.size]}px`,
  borderColor: `${theme.resolveColor(props.color)}`,
  borderWidth: `${boarders[props.size]}px`,
  borderRight: `${boarders[props.size]}px solid transparent`,
}));

</script>

<style scoped>
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid;
  border-right: 0.25em solid transparent;
  border-radius: 50%;
  -webkit-animation: spinner-border .75s linear infinite;
  animation: spinner-border .75s linear infinite;
}

@-webkit-keyframes spinner-border {
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0,0,0,0);
  white-space: nowrap;
  border: 0;
}

</style>
